const root = document.documentElement;
const body = document.body;
const variantGlobals = [
  'fullstackDuplicatedProductVariant',
  'igDuplicatedProductVariant',
  'IntelligemsDuplicatedProductVariant',
];
const testValues = new Set(['1', 'true', 'test', 'duplicate', 'duplicated', 'variant-b', 'variation-b', 'b']);

const getVariantValue = () => {
  for (const globalName of variantGlobals) {
    if (window[globalName] !== undefined) return window[globalName];
  }

  return null;
};

const isTestVariant = (value) => {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value === 1;
  if (typeof value !== 'string') return false;

  return testValues.has(value.trim().toLowerCase());
};

const redirectToDuplicatedProduct = () => {
  if (window.fullstackDuplicatedProductRedirect === false) return;

  const duplicatedProductUrl = body?.dataset.abDuplicatedProductUrl;
  if (!duplicatedProductUrl) return;

  const targetUrl = new URL(duplicatedProductUrl, window.location.origin);
  if (targetUrl.pathname === window.location.pathname) return;

  if (window.location.search && !targetUrl.search) {
    targetUrl.search = window.location.search;
  }

  window.location.replace(targetUrl.href);
};

const applyDuplicatedProductVariant = () => {
  const variantValue = getVariantValue();
  if (variantValue === null || variantValue === '') return false;

  const shouldUseDuplicatedProduct = isTestVariant(variantValue);

  root.classList.toggle('ab-duplicated-products--test', shouldUseDuplicatedProduct);
  root.classList.toggle('ab-duplicated-products--control', !shouldUseDuplicatedProduct);

  if (shouldUseDuplicatedProduct) {
    redirectToDuplicatedProduct();
  }

  return true;
};

applyDuplicatedProductVariant();

let attempts = 0;
const variantWatcher = window.setInterval(() => {
  attempts += 1;

  if (applyDuplicatedProductVariant() || attempts >= 80) {
    window.clearInterval(variantWatcher);
  }
}, 50);

window.addEventListener('intelligems:loaded', applyDuplicatedProductVariant);
window.addEventListener('fullstack:duplicated-products-variant-change', applyDuplicatedProductVariant);
